export const isEmptyString = (str: string) => str === '';
